import { Injectable } from '@angular/core';
import { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';
import { CarCategoryPageInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-page.dto';
import { CarCategoryQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountCarCategoryService extends BaseService {
  protected baseUrl = '/personal-account/cctv/car-category';

  public findWithPagination(queryParams: CarCategoryQueryInterface): Observable<CarCategoryPageInterface> {
    return this.http.get<CarCategoryPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public findDefault(): Observable<CarCategoryFindInterface> {
    return this.http.get<CarCategoryFindInterface>(`${this.baseUrl}/default`);
  }
}
